import { type Organisation } from '@aikoa/common'
import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import { Body, Label } from '~/components/typography/Content'

type OrganisationPreviewProps = {
  organisation: Organisation
}

export function OrganisationPreview({ organisation }: OrganisationPreviewProps) {
  const { t } = useTranslations('admin')

  return (
    <View className="gap-4 rounded-lg border border-neutral-200 bg-white p-4">
      <Body className="text-sm text-secondary">
        {t(($) => $.createUser.organisation.willJoinExisting)}
      </Body>

      <View className="gap-1">
        <Label className="font-semibold text-lg">{organisation.name}</Label>
        <Body className="text-sm text-secondary">{organisation.email_domain}</Body>
      </View>
    </View>
  )
}
